/**
 * Returns a full CW finance request
 * @param {object} vehicleObject
 * @param {object} financeKeyObject
 * @param {object} customerParametersObject
 */
export default function(vehicleObject, financeKeyObject, customerParametersObject) {
    let data = {
        "Credentials":{
            "ApiKey":"ONH75GHd8x0gu6yfJ6"
            },
        "Customer":{
            "Reference":customerParametersObject.customerRef
        },
        "Parameters":{
            "Term": customerParametersObject.getTerm(financeKeyObject),
            "Deposit": customerParametersObject.getDeposit(financeKeyObject),
            "DepositType":"Amount",
            "AnnualMileage": customerParametersObject.getMileage(financeKeyObject),
            "IsTelematics": financeKeyObject.isTelematics,
        },
        "VehicleRequests":[
            vehicleObject.getCodeweaversRequestObject(financeKeyObject)
        ]
    };

    const postcode = customerParametersObject.getPostcode();
    if (postcode !== '') {
        data.Customer.Postcode = postcode;
    }

    const age = customerParametersObject.getAge();
    if (age !== '' && age > 0) {
        data.Customer.Age = age;
    }

    // Duplicate the Parameters into any vehicle override requests
    if (data.VehicleRequests.length > 0) {
        data.VehicleRequests.forEach((vehicleRequest, vehicleRequestIndex) => {
            if (typeof vehicleRequest.Products == 'undefined') {
                return;
            }
            if (vehicleRequest.Products.length == 0) {
                return;
            }
            vehicleRequest.Products.forEach((product, productIndex) => {
                if (typeof product.OverrideFinanceParameters == 'undefined') {
                    return;
                }
                data.VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.Term = data.Parameters.Term;
                data.VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.Deposit = data.Parameters.Deposit;
                data.VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.DepositType = data.Parameters.DepositType;
                data.VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.AnnualMileage = data.Parameters.AnnualMileage;
                data.VehicleRequests[vehicleRequestIndex].Products[productIndex].OverrideFinanceParameters.IsTelematics = data.Parameters.IsTelematics;
            });
        })
    }

    return data;
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-request.js